






















import Vue, { PropType } from "vue";
import { ActivityStatus } from "@/consts";
export default Vue.extend({
  name: "Calender",
  props: {
    cheerNum: {
      type: Number,
      default: 0
    },
    status: {
      type: Number as PropType<ActivityStatus>,
      default: ActivityStatus.NOT_START
    },
    message: {
      type: String,
      default: ""
    },
    showWalletBtn: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPhase(): string {
      if (this.status === ActivityStatus.NOT_START || this.status === ActivityStatus.COLLECTING) {
        return "phase-1";
      } else {
        return "phase-2";
      }
    }
  },
  data: () => ({}),
  filters: {
    numberWithCommas(numStr: number): string {
      return numStr.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  methods: {
    walletClicked() {
      this.$emit("wallet-clicked");
    }
  }
});
